function renderVideo() {
    var video = document.getElementById("fwv-video-container");
    var background = document.getElementById("fwv-background");
    var iframe = document.getElementById("fwv-video");
    video.style.display = "block";
    background.style.visibility = "hidden";
    if(iframe.src.includes("autoplay=0")){
        iframe.src = iframe.src.replace("autoplay=0", "autoplay=1");
    }
    iframe.addEventListener("fullscreenchange", () => {
        closeVideoIfFullscreenActive(iframe, video, background);
    });
}

function closeVideoIfFullscreenActive(iframe, video, background) {
    if(document.fullscreenElement == null){         
        iframe.src = iframe.src.replace("autoplay=1", "autoplay=0");
        video.style.display = "none";
        background.style.visibility = "visible";
    }
}